<h2 class="f-wb">
  {{ 'reports.run-a-report.reports' | translate | titlecase }}
</h2>
@if (reportsList != null && reportsList.length > 0) {
<p-accordion [value]="reportsList">
  @for (report of reportsList; track report.Title) {
  <p-accordion-panel [value]="report">
    <p-accordion-header>{{ report.Title }}</p-accordion-header>
    <p-accordion-content>
      @for (child of report.ChildItems; track child.Title) {
      @if ((child.ChildItems?.length ?? 0) == 0) {
      <div class="mt-4 mb-4">
        <a (click)="openReport(child)">{{ child.Title }}</a>
      </div>
      }
      @if ((child.ChildItems?.length ?? 0) > 0)
      {
      <div class="mt-8">
        <p-accordion [value]="child.Title">
          <p-accordion-panel [value]="child">
            <p-accordion-header>{{ child.Title }}</p-accordion-header>
            <p-accordion-content>
              @for (grandchild of child.ChildItems; track grandchild.Title) {
              <div class="mb-8">
                <div class="mt-4 mb-4" *ngIf="grandchild.ChildItems?.length ??0 == 0">
                  <a (click)="openReport(grandchild)">{{ grandchild.Title }}</a>
                </div>
              </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
      }
      }
    </p-accordion-content>
  </p-accordion-panel>
  }
</p-accordion>
}